export default __webpack_public_path__ + "files/dd7f8efc8a9cf4ef91481f79522de6a3.svg";